import React, { PureComponent } from 'react';

import * as AppActions from './AppState';

import Loader from '../../components/Loader';
import Barchart from '../../components/Barchart';
import Slider from '../../components/Slider';
import Menu from '../../components/Menu';
import SelectMenu from '../../components/Menu/SelectMenu';
import Header from '../../components/Header/';
import Infobox from '../../components/Infobox';
import Faq from '../../components/Infobox/faq';
import Embed from '../../components/Infobox/embed';
import GroupInfoText from '../../components/GroupInfoText';
import Footer from '../../components/Footer';

import 'normalize.css';
import './App.styl';

class App extends PureComponent {
  constructor() {
    super()

    this.toggleFaqBox = this.toggleFaqBox.bind(this);
    this.toggleEmbedBox = this.toggleEmbedBox.bind(this);
  }

  componentWillUpdate(nextProps) {
    if (nextProps.currentDataSet && (this.props.currentDataSet !== nextProps.currentDataSet)) {
      this.props.dispatch(AppActions.loadData(nextProps.currentDataSet));
    }
  }

  componentDidMount() {
    this.props.dispatch(AppActions.loadData());
  }

  toggleFaqBox() {
    this.props.dispatch(AppActions.toggleFaq());
  }

  toggleEmbedBox() {
    this.props.dispatch(AppActions.toggleEmbed());
  }

  render() {
    return (
      <div className="ifdw-app">
        <h1>Wer zur Mittelschicht gehört</h1>
        <div className="clearfix"><Header dispatch={this.props.dispatch} /></div>
        <Infobox handler={this.toggleFaqBox} isActive={this.props.faqActive} component={<Faq />} />
        <Infobox handler={this.toggleEmbedBox} isActive={this.props.embedActive} component={<Embed />} />
          <div className="ifdw-container clearfix">
            <div className="ifdw-menu">
              <Menu items={this.props.datasets} dispatch={this.props.dispatch} activeItem={this.props.currentDataSet}/>
              <SelectMenu items={this.props.datasets} dispatch={this.props.dispatch} activeItem={this.props.currentDataSet}/>
            </div>
            <div className="ifdw-vis">
              {this.props.loading && <Loader/>}
              <Slider dispatch={this.props.dispatch} year={this.props.year} isPlaying={this.props.isPlaying}/>
              <GroupInfoText currentDataSet={this.props.currentDataSet} />
              {this.props.allData && <Barchart allData={this.props.allData} subData={this.props.subData} year={this.props.year}/>}
              <Footer dispatch={this.props.dispatch} />
            </div>
          </div>
      </div>
    );
  }
}

export default App;



/** WEBPACK FOOTER **
 ** ./src/modules/App/App.js
 **/